"use client";
import { useEffect } from "react";

import SVG from "react-inlinesvg";
import Image from "next/image";
import { useParams } from "next/navigation";
import Link from "next/link";
import { fromDataAtom } from "@/scripts/store";
import { useAtom } from "jotai";


export default function PageComponent({  }) {

  const params = useParams()
  const [fromData, set_fromData]: any = useAtom(fromDataAtom);
  useEffect(()=>{
    set_fromData(null);
  },[])
  


  return (
    <main className="page page-contact">
      <div className="container-m">

        <div className="page-title-holder">
          <h1 className="h1-title">
            <span className="shoulder">お問い合わせ</span>
            <span className="title en">Contact</span>
          </h1>
        </div>

        <section className="section">
          {/* <ul className="underline-list">
            <li className="underline-list-item">
              <div className="title">営業時間</div>
              <div className="text">平日10時〜19時</div>
            </li>
            <li className="underline-list-item">
              <div className="title">定休日</div>
              <div className="text">土日祝</div>
            </li>
          </ul> */}

          <div className="contact-link-list">
            <Link className="contact-link-list-item scaleHover" href="/contact/farmers/">
              <div className="inner">
                <div className="title-holder">
                  <div className="title bold">農家の方はこちら</div>
                  <div className="text">農業支援（Next Green Method）や野菜ブランド（Next Green Vegetables）についてのお問い合わせ</div>
                </div>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                </i>
              </div>
            </Link>
            <Link className="contact-link-list-item scaleHover" href="/contact/companies/">
              <div className="inner">
                <div className="title-holder">
                  <div className="title bold">企業の方はこちら</div>
                  <div className="text">ソリューション導入やコンサルティング、協業についてのお問い合わせ</div>
                </div>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                </i>
              </div>
            </Link>
            <Link className="contact-link-list-item scaleHover" href="/contact/media/">
              <div className="inner">
                <div className="title-holder">
                  <div className="title bold">メディアの方はこちら</div>
                  <div className="text">取材に関するお問い合わせ</div>
                </div>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                </i>
              </div>
            </Link>
            <Link className="contact-link-list-item scaleHover" href="/contact/general/">
              <div className="inner">
                <div className="title-holder">
                  <div className="text bold">その他</div>
                </div>
                <i className="icon">
                  <SVG src="/assets/img/common/icon/icon-arrow-right.svg" />
                </i>
              </div>
            </Link>
          </div>
        </section>
      </div>
    </main>
  );
}
